<app-access-item>
  <app-access-item-icon>
    <app-gallery-settings-icon src="/assets/icons/color-bucket.svg"> </app-gallery-settings-icon>
  </app-access-item-icon>
  <app-access-item-header [comingSoon]="true">
    <div>Background</div>
  </app-access-item-header>

  <app-access-item-cta>
    <div class="colors">
      <!-- <div
        class="color-selector white"
        (click)="updateColor('white')"
        [class.selected]="!theme().asset_page.background_color || theme().asset_page.background_color === 'white'"
      ></div> -->
      <div
        class="color-selector black"
        [class.selected]="theme().asset_page.background_color === 'black'"
        [class.disabled]="true"
        (click)="updateColor('black')"
      ></div>
    </div>
  </app-access-item-cta>
</app-access-item>
